import { Alert, Flex, Modal } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text } from 'components/mvp-typography';
import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';

interface ConfirmOnDemandPurchaseModalProps {
  showModal: boolean;
  onClose: () => void;
  onReviewPurchase: () => void;
  assessmentType: AssessmentType;
}

export function ConfirmOnDemandPurchaseModal(
  props: ConfirmOnDemandPurchaseModalProps
) {
  return (
    <Modal
      title="Confirm pay-per-use purchase"
      open={props.showModal}
      onCancel={props.onClose}
      footer={[
        // TODO: Center the button on the modal
        <BaseButton key="review" onClick={props.onReviewPurchase}>
          Review purchase
        </BaseButton>
        // <BaseButton key="top-up" onClick={props.onReviewPurchase} type="default">
        //   Top-up balance
        // </BaseButton>,
      ]}
    >
      <Flex vertical gap={16}>
        <Alert
          type="warning"
          showIcon
          message={"Zero balance"}
          description={
            <Text>
              Your balance for the <b>{props.assessmentType}</b> assessment is
              zero.
            </Text>
          }
        />
        <Text>
          Your organisation has enabled pay-per-use purchases of assessments.
          Please confirm if you would like to purchase a single assessment.
        </Text>
        <Text>
          This purchase is non-refundable. If the assessment is cancelled, the
          assessment will be added to your balance.
        </Text>
      </Flex>
    </Modal>
  );
}
